import React, { useEffect, useState } from 'react';
import { Layout as AntdLayout, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { NavLink } from 'react-router-dom';
import Menu from './Menu';
import ReduxRedirect from '../Common/ReduxRedirect';
import { MainLogo } from '../Common/Icon';

import styles from './index.module.scss';

const { Header, Sider, Content } = AntdLayout;

interface LayoutProps {
  title?: string;
  LeftMenu?: React.FC<{ collapsed?: boolean }>;
  leftMenu?: React.ReactNode;
  transparent?: boolean;
  disableLeftMenu?: boolean;
  children: React.ReactNode;
  collapsedByDefault?: boolean;
  minWidth?: boolean;
  headerContent?: React.ReactNode;
}

let defaultStateCollapsed = false;

function Layout({
  disableLeftMenu = false,
  title,
  LeftMenu,
  leftMenu = <Menu />,
  transparent,
  children,
  collapsedByDefault = false,
  minWidth,
  headerContent,
}: LayoutProps): React.ReactNode {
  const [collapsed, setCollapsed] = useState(defaultStateCollapsed);
  // const {
  //   token: { colorBgContainer = 'transparent' },
  // } = theme.useToken();
  const isTablet = useMediaQuery({
    query: '(max-width: 1024px)',
  });
  const disableMenu = disableLeftMenu || (!LeftMenu && !leftMenu);

  useEffect(() => {
    defaultStateCollapsed = collapsed;
  }, [collapsed]);

  useEffect(() => {
    if ((isTablet && !disableMenu) || collapsedByDefault) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [isTablet, disableMenu]);

  return (
    <>
      <ReduxRedirect />
      <AntdLayout hasSider className={styles.layout}>
        {disableMenu ? null : (
          <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            className={clsx(styles.slider, { [styles.absolute]: isTablet && !disableMenu })}
            width={208} // 208
            collapsedWidth={64} // 48
          >
            <NavLink to="/" className={clsx(styles.logo, { [styles.collapsed]: collapsed })}>
              <MainLogo height="64" />
              {/* {collapsed ? <img src="/logo.png" className={styles.logoSvg} alt="Gruuun" /> : null} */}

              {/* {!collapsed ? <img src="/logo.png" className={styles.logoSvg} alt="Gruuun" /> : null} */}
            </NavLink>

            <div className={clsx(styles.menu, { [styles.collapsed]: collapsed })}>
              {LeftMenu ? <LeftMenu /> : leftMenu}
            </div>

            <Button
              type="text"
              icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className={clsx(styles.btn, { [styles.collapsed]: collapsed })}
            />
          </Sider>
        )}
        <AntdLayout className={clsx(styles.wrapper, { [styles.tablet]: isTablet && !disableMenu })}>
          {/* <Header
            // style={{ background: colorBgContainer }}
            className={clsx(styles.header, { [styles.headerLogo]: disableMenu })}
          >
            {disableMenu ? (
              <NavLink to="/" className={clsx(styles.logo, { [styles.tablet]: isTablet })}>
                <MainLogo height="64" />
              </NavLink>
            ) : null}

            {title ? (<h1>{title}</h1>) : null}
          </Header> */}
          <div className={clsx(styles.scroll, { [styles.collapsed]: collapsed })}>
            <Content
              className={clsx(
                styles.content,
                { [styles.transparent]: transparent },
                { [styles.minWidth]: isTablet && minWidth },
              )}
              id="layout-content"
            >
              {children}
            </Content>
          </div>
        </AntdLayout>
      </AntdLayout>
    </>
  );
}

export default Layout;
